import { Venue } from '../../core/classes/Venue';
import { Address } from '../../core/classes/Address';

export const calculateGeoDistance = ([lat1, lon1]: [number, number], [lat2, lon2]: [number, number]) => {
	function deg2rad(deg: number) {
		return deg * (Math.PI / 180);
	}

	const r = 6371;
	const dLat = deg2rad(lat2 - lat1);
	const dLon = deg2rad(lon2 - lon1);

	const a = Math.sin(dLat / 2) ** 2 + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) ** 2;

	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	return r * c;
};

export const sortVenuesByDistance = (venues: Venue[]) => {
	return venues.sort((a, b) => a.distanceToUser - b.distanceToUser);
};

export const addressString = (a: Address): string => {
	if (!a) return '';
	return `${a.street || '--'} ${a.number || '--'}, ${a.postalCode || '--'} ${a.city}`;
};
